import {
  AddManyWorkOrderCommission,
  AddManyWorkOrderCommissionState,
} from '@/core/domain/workorder/WorkOrdersCommisions/WorkOrdersCommissions.types';
import { notification } from 'antd';

type HandlerCommissionsValues = AddManyWorkOrderCommissionState & {
  complementId: number;
  employeeId?: number;
};

export default function handlerCommissionsValues(
  values: HandlerCommissionsValues,
  callback: (data: AddManyWorkOrderCommission) => void,
) {
  const { items, employeeId, complementId } = values;

  if (!items?.length || !items.some((item) => item.checked)) {
    notification.warning({
      message: 'Comissão',
      description:
        'É necessário a seleção de pelo menos 1 item da comissão para o envio.',
    });
  } else if (complementId && typeof employeeId === 'number') {
    callback({
      complementId,
      employeeId,
      items: items
        .filter((item) => item.checked)
        .map((item) => ({
          itemId: item.itemId,
          baseValue: item.baseValue,
          percent: item.percent,
          quantity: item.commissionQuantity,
          commissionBaseValue: item.commissionBaseValue,
        })),
    });
  }
}
